import { render, staticRenderFns } from "./EmployeeCompanyEmailField.vue?vue&type=template&id=3b272fc1&"
import script from "./EmployeeCompanyEmailField.vue?vue&type=script&lang=js&"
export * from "./EmployeeCompanyEmailField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b272fc1')) {
      api.createRecord('3b272fc1', component.options)
    } else {
      api.reload('3b272fc1', component.options)
    }
    module.hot.accept("./EmployeeCompanyEmailField.vue?vue&type=template&id=3b272fc1&", function () {
      api.rerender('3b272fc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/fields/EmployeeCompanyEmailField.vue"
export default component.exports